<div class="campaign-term"
     [ngClass]="{'campaign-term-select': selected, 'read-only': isReadOnly}"
     actionByLevels="Basic brief"
     [wallName]="'Campaign Disabled'"
     (afterChecking)="onSelect($event)">
  <div *ngIf="!campaignTerm.hasParams">
    <span class="text-bold-font">{{campaignTerm.summary}}</span>
  </div>
  <div *ngIf="campaignTerm.hasParams">
    <span class="text-bold-font" *ngFor="let param of campaignTerm.params">
      <span class="text-bold-font" *ngIf="param.paramType === 0">{{param.content}}</span>
      <span *ngIf="param.paramType === 1">
        <input class="param-input" [ngClass]="{'selected': selected}"
               actionByLevels="Basic brief"
               [wallName]="'Campaign Disabled'"
               (afterChecking)="$event.stopPropagation()"
               [(ngModel)]="param.value" type="text" [disabled]="isReadOnly">
      </span>
    </span>
  </div>
  <div class="buttons d-flex flex-g1 justify-content-end" *ngIf="!campaignTerm.systemWide">
    <button class="button gray" *ngIf="!campaignTerm.isUsed"
            [disabled]="isReadOnly"
            actionByLevels="Basic brief"
            [wallName]="'Campaign Disabled'"
            (afterChecking)="delete($event, campaignTerm.id)">
      {{'common.btn.delete' | translate}}
    </button>
    <button class="button blue" *ngIf="!campaignTerm.isUsed"
            [disabled]="isReadOnly"
            actionByLevels="Basic brief"
            [wallName]="'Campaign Disabled'"
            (afterChecking)="edit($event, campaignTerm)">
      {{'common.btn.edit' | translate}}
    </button>
  </div>
  <span *ngIf="selected" class="icon-selected">
    <svg width="17px" height="12px" viewBox="0 0 22 17" version="1.1">
        <defs></defs>
        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="Checkmark/blue" transform="translate(-4.000000, -10.000000)" fill="#55ACEE">
                <g id="Group" transform="translate(14.620294, 16.122347) rotate(-315.000000) translate(-14.620294, -16.122347) translate(8.620294, 6.122347)">
                    <path d="M8.62746211,15.7535173 L8.62746211,-0.000468973417 L11.6274621,-0.000468973417 L11.6274621,19.128869 L8.62746211,19.128869 L8.62746211,18.7535173 L0.517864081,18.7535173 L0.517864081,15.7535173 L8.62746211,15.7535173 Z" id="Combined-Shape"></path>
                </g>
            </g>
        </g>
    </svg>
  </span>
</div>



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/campaign-term/campaign-term.component.html